window.openUrlExternal = url => {
  if (window.appOpenUrl) {
    window.appOpenUrl(url)
  } else {
    window.open(url)
  }
}
